/**
 * Main layout for project section
 * Maps all projects from ./projectList.tsx using
 * project sections
 */
import React, { useState } from 'react';

// style imports
import { ProjectSectionContainer, 
  ProjectTypeButton,
} from '../../../styles/sectionStyles/ProjectSectionStyles';
import { SectionHeader, SectionText } from '../../../styles/CoreStyle';

// grid import from material
import { Grid } from '@material-ui/core';

// card import
import ProjectCard from './ProjectCard';


// fade in lazy load
import Fade from 'react-reveal';
import Jump from 'react-reveal/Jump';
import Tada from 'react-reveal/Tada';

// projects list import
import { projectList,
  UniProjectsList, 
} from './ProjectsList';

import { isMobile } from 'react-device-detect';

import Carousel from 'react-material-ui-carousel'

export function ProjectSection () {
  const [projectType, setProjectType] = useState('Personal');
  const [projectTypeDelayed, setProjectTypeDelayed] = useState('Personal');

  const handleProjectTypeChange = ( type ) => {
    setProjectType(type);
    // delayed change to wait for animation to complete
    setTimeout(function () {
      setProjectTypeDelayed(type);
      // Vibrate if mobile and the browser can vibrate
      if (isMobile && navigator.vibrate) {
        navigator.vibrate(50);
      }
    }, 450);
  }

  return (
    <>
      <Fade fraction={0.1}>
        <SectionHeader id='projects'>Projects</SectionHeader>
        <SectionText style={{textAlign: 'center'}}>What I've been doing in<br />
        <Tada spy={projectType}> 
          {projectTypeDelayed === 'Personal' 
          ? <div style={{color: '#94D1FE', display: 'inline-block'}}>my spare time</div> 
          : <div style={{color :'#FFDD00', display: 'inline-block'}}>university</div>}
        </Tada>
          <br />
          <>
            <ProjectTypeButton id='personalProjectCheck' 
              selected={projectType === 'Personal'} 
              onClick={() => handleProjectTypeChange('Personal')}
              projectType={projectType}
            >
              Personal
            </ ProjectTypeButton>
            <ProjectTypeButton 
              id='uniProjectCheck' 
              selected={projectType === 'Uni'}
              onClick={() => handleProjectTypeChange('Uni')}
              projectType={projectType}
            >
              Uni
            </ ProjectTypeButton>
          </>

        </SectionText>
        {/* Not delayed because the animation itself is slower */}
        <Jump spy={projectType}>
          <ProjectSectionContainer key={projectTypeDelayed}>
            <Carousel 
              className='carouselReaction'
              animation='slide'
              navButtonsAlwaysVisible
              interval='15000'
            >
              {(projectTypeDelayed === 'Personal' ? projectList : UniProjectsList).map((project, key) => {
                return (
                    <ProjectCard key={key} projectData={project} /> 
                );
              })}
            </Carousel>
            <Grid container
              direction="row"
              justifyContent="center"
              alignItems="center"
              style={{height: '80%', marginBottom: '25px'}}
              className='gridReaction'
            >
              {(projectTypeDelayed === 'Personal' ? projectList : UniProjectsList).map((project, key) => {
                return (
                  <Grid key={key} item style={{margin: '15px', width: '350px'}}> 
                    <ProjectCard  projectData={project} />
                  </Grid>);
              })}
            </Grid>
          </ProjectSectionContainer>
        </Jump>
      </Fade>
    </>
  );
}
